export default "__VITE_ASSET__xjbJtPpp__"